<template>
  <div>
    <div class="pc_newsList">
      <div class="newsList">
      <ul>
        <li v-for="item in dataList" :key="item.id" @click="hinditem(item)">
          <div class="newsleft">
            <img :src="item.titleImg" alt />
          </div>
          <div class="newsright">
            <p>
              <span>{{item.title}}</span>
              <span>{{item.mtime.substring(0,10)}}</span>
            </p>
            <p>{{item.synopsis}}</p>
          </div>
        </li>
      </ul>
    </div>
    </div>
    <div class="mobile_newsList">
      <ul class="mobile_list">
        <li v-for="item in dataList" :key="item.id" @click="hinditem(item)">
          <div class="mobile_newsleft">
            <img :src="item.titleImg" alt />
          </div>
          <div class="mobile_newsright">
              <p>{{item.title}}</p>
              <p>{{item.synopsis}}</p>
              <p>{{item.mtime.substring(0,10)}}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {
    hinditem (val) {
      this.$emit('binditem', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .pc_newsList {
    display: none;
  }
}
.mobile_newsList {
  display: none;
}
.mobile_list{
  width: 100%;
  padding: 0 10px 20px 10px;
  box-sizing: border-box;
  li{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px auto;
    .mobile_newsleft{
      width: 100%;
      height: 160px;
      img{
        height: 100%;
        width: 100%;
      }
    }
    .mobile_newsright{
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 100%;
      height: 209px;
      padding: 0 15px;
      box-sizing: border-box;
      border:1px solid rgba(216,216,216,1);
      background:rgba(255,255,255,1);
      p:nth-of-type(1){
        font-size:13px;
        line-height:18px;
        color:rgba(0,0,0,1);
      }
      p:nth-of-type(2){
        height: 112px;
        font-size:10px;
        line-height:15px;
        color:#000;
        text-align: justify;
        display: flex;
        align-items: center;
      }
      p:nth-of-type(3){
        font-size:10px;
        line-height:14px;
        color:#B2B2B2;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .mobile_newsList {
    display: block;
  }
}
.newsList {
  width: 87%;
  margin: 0.5rem auto;
  ul {
    width: 100%;
    li {
      box-sizing: border-box;
      height: 4.34rem;
      border-bottom: 0.01rem solid rgba(234, 234, 234, 1);
      cursor: pointer;
      .newsleft {
        float: left;
        width: 29%;
        height: 2.68rem;
        line-height: 6.1;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .newsright {
        float: left;
        width: 70%;
        padding-left: 1.03rem;
        padding-right: 0.8rem;
        height: 61%;
        line-height: 61%;
        box-sizing: border-box;
        p:nth-of-type(1) {
          float: left;
          height: 45%;
          width: 100%;
          margin-top: 0.65rem;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-word;
          span:nth-of-type(1) {
            float: left;
            width: 7.48rem;
            font-size: 0.3rem;
            font-weight: 500;
            color: #0982D6;
            line-height: 0.4rem;
          }
          span:nth-of-type(2) {
            float: right;
            width: 1.5rem;
            font-size: 0.2rem;
            font-weight: 500;
            color: rgba(136, 136, 136, 1);
            line-height: 0.3rem;
            white-space: nowrap;
          }
        }
        p:nth-of-type(2) {
          width: 81%;
          font-size: 0.2rem;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          line-height: 0.3rem;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: justify;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/newList.vue